// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__379q5","unreadBadge":"styles_unreadBadge__2Phm5","modalContent":"styles_modalContent__3hPtM","modal":"styles_modal__3nG1L"};